export default {
  pt: {
    'conjuntos.transferenciasPage.requested': 'Transferência solicitada.',
    'conjuntos.transferenciasPage.updated': 'Transferência atualizada.',
    'conjuntos.transferenciasPage.set': 'Conjunto',
    'conjuntos.transferenciasPage.from': 'De',
    'conjuntos.transferenciasPage.to': 'Para',
    'conjuntos.transferenciasPage.status.pending': 'Pendente',
    'conjuntos.transferenciasPage.status.accepted': 'Aceita',
    'conjuntos.transferenciasPage.status.rejected': 'Recusada',
    'conjuntos.transferenciasPage.status.cancelled': 'Cancelada',
    'conjuntos.transferenciasPage.requestedAt': 'Solicitada',
    'conjuntos.transferenciasPage.accept': 'Aceitar',
    'conjuntos.transferenciasPage.reject': 'Recusar',
    'conjuntos.transferenciasPage.title': 'Transferências',
    'conjuntos.transferenciasPage.eyebrow': 'Conjuntos',
    'conjuntos.transferenciasPage.newTransfer': 'Nova transferência',
    'conjuntos.transferenciasPage.empty': 'Nenhuma transferência.',
    'conjuntos.transferenciasPage.searchSet': 'Buscar conjunto…',
    'conjuntos.transferenciasPage.toPair': 'Para a dupla',
    'conjuntos.transferenciasPage.searchPair': 'Buscar dupla…',
    'conjuntos.transferenciasPage.sending': 'Enviando…',
    'conjuntos.transferenciasPage.request': 'Solicitar',
    'conjuntos.transferenciasPage.transferred': 'Conjunto transferido.',
    'conjuntos.transferenciasPage.responsible': 'Usuário responsável',
    'conjuntos.transferenciasPage.transferredAt': 'Data e hora da transferência',
    'conjuntos.transferenciasPage.driver': 'Motorista',
    'conjuntos.transferenciasPage.searchDriver': 'Buscar motorista…',
    'conjuntos.transferenciasPage.plate': 'Placa',
    'conjuntos.transferenciasPage.pair': 'Dupla',
    'conjuntos.transferenciasPage.fromDate': 'De',
    'conjuntos.transferenciasPage.toDate': 'Até',
    'conjuntos.transferenciasPage.transferring': 'Transferindo…',
    'conjuntos.transferenciasPage.transfer': 'Transferir',
  },
  en: {
    'conjuntos.transferenciasPage.requested': 'Transfer requested.',
    'conjuntos.transferenciasPage.updated': 'Transfer updated.',
    'conjuntos.transferenciasPage.set': 'Set',
    'conjuntos.transferenciasPage.from': 'From',
    'conjuntos.transferenciasPage.to': 'To',
    'conjuntos.transferenciasPage.status.pending': 'Pending',
    'conjuntos.transferenciasPage.status.accepted': 'Accepted',
    'conjuntos.transferenciasPage.status.rejected': 'Rejected',
    'conjuntos.transferenciasPage.status.cancelled': 'Cancelled',
    'conjuntos.transferenciasPage.requestedAt': 'Requested',
    'conjuntos.transferenciasPage.accept': 'Accept',
    'conjuntos.transferenciasPage.reject': 'Reject',
    'conjuntos.transferenciasPage.title': 'Transfers',
    'conjuntos.transferenciasPage.eyebrow': 'Sets',
    'conjuntos.transferenciasPage.newTransfer': 'New transfer',
    'conjuntos.transferenciasPage.empty': 'No transfers.',
    'conjuntos.transferenciasPage.searchSet': 'Search set…',
    'conjuntos.transferenciasPage.toPair': 'To pair',
    'conjuntos.transferenciasPage.searchPair': 'Search pair…',
    'conjuntos.transferenciasPage.sending': 'Sending…',
    'conjuntos.transferenciasPage.request': 'Request',
    'conjuntos.transferenciasPage.transferred': 'Set transferred.',
    'conjuntos.transferenciasPage.responsible': 'Responsible user',
    'conjuntos.transferenciasPage.transferredAt': 'Transfer date and time',
    'conjuntos.transferenciasPage.driver': 'Driver',
    'conjuntos.transferenciasPage.searchDriver': 'Search driver…',
    'conjuntos.transferenciasPage.plate': 'Plate',
    'conjuntos.transferenciasPage.pair': 'Pair',
    'conjuntos.transferenciasPage.fromDate': 'From',
    'conjuntos.transferenciasPage.toDate': 'To',
    'conjuntos.transferenciasPage.transferring': 'Transferring…',
    'conjuntos.transferenciasPage.transfer': 'Transfer',
  },
  es: {
    'conjuntos.transferenciasPage.requested': 'Transferencia solicitada.',
    'conjuntos.transferenciasPage.updated': 'Transferencia actualizada.',
    'conjuntos.transferenciasPage.set': 'Conjunto',
    'conjuntos.transferenciasPage.from': 'De',
    'conjuntos.transferenciasPage.to': 'Para',
    'conjuntos.transferenciasPage.status.pending': 'Pendiente',
    'conjuntos.transferenciasPage.status.accepted': 'Aceptada',
    'conjuntos.transferenciasPage.status.rejected': 'Rechazada',
    'conjuntos.transferenciasPage.status.cancelled': 'Cancelada',
    'conjuntos.transferenciasPage.requestedAt': 'Solicitada',
    'conjuntos.transferenciasPage.accept': 'Aceptar',
    'conjuntos.transferenciasPage.reject': 'Rechazar',
    'conjuntos.transferenciasPage.title': 'Transferencias',
    'conjuntos.transferenciasPage.eyebrow': 'Conjuntos',
    'conjuntos.transferenciasPage.newTransfer': 'Nueva transferencia',
    'conjuntos.transferenciasPage.empty': 'No hay transferencias.',
    'conjuntos.transferenciasPage.searchSet': 'Buscar conjunto…',
    'conjuntos.transferenciasPage.toPair': 'Para la pareja',
    'conjuntos.transferenciasPage.searchPair': 'Buscar pareja…',
    'conjuntos.transferenciasPage.sending': 'Enviando…',
    'conjuntos.transferenciasPage.request': 'Solicitar',
    'conjuntos.transferenciasPage.transferred': 'Conjunto transferido.',
    'conjuntos.transferenciasPage.responsible': 'Usuario responsable',
    'conjuntos.transferenciasPage.transferredAt': 'Fecha y hora de transferencia',
    'conjuntos.transferenciasPage.driver': 'Conductor',
    'conjuntos.transferenciasPage.searchDriver': 'Buscar conductor…',
    'conjuntos.transferenciasPage.plate': 'Matrícula',
    'conjuntos.transferenciasPage.pair': 'Pareja',
    'conjuntos.transferenciasPage.fromDate': 'Desde',
    'conjuntos.transferenciasPage.toDate': 'Hasta',
    'conjuntos.transferenciasPage.transferring': 'Transfiriendo…',
    'conjuntos.transferenciasPage.transfer': 'Transferir',
  },
}
